// @generated by tools/docgen — do not edit.
// Source: docs/project-status.md

import React from 'react';

export function ProjectStatusPage() {
  return (
    <div className="mx-auto w-full max-w-3xl flex-1 overflow-y-auto px-6 py-10">
      <h1 className="text-2xl font-semibold tracking-tight text-ink">
        Project status
      </h1>
      <p className="mt-4 max-w-prose text-base leading-relaxed text-primary-800">
        We have built the main project semantics and core functionality. There's still a roadmap ahead for v0.1. Now that the site is functional, we have the next big engineering effort: the model architecture. Give us a star at <a href="https://github.com/rxdjango/rxdjango" className="text-primary-700 hover:underline">Github</a> to keep updated with the development!
      </p>
    </div>
  );
}

export default ProjectStatusPage;
